export default function fixPoetName(poetID){
  switch(poetID) {
    case 'wbyeats':
        return 'W. B. Yeats'
    default:
        return poetID.charAt(0).toUpperCase() + poetID.slice(1);
  }
}



// WEBPACK FOOTER //
// ./src/helpers/fixPoetName.js